import React from 'react';
import { Grid } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import { ICampoIndiceProps } from './ICampoIndiceProps';

export const CampoData: React.FC<ICampoIndiceProps> = ({ indice, valor, disabled, onChange }) => {
    return (
        <Grid item xs={12} sm={12} md={6} key={indice.idIndice}>
            <DatePicker
                key={'TextFieldData-' + indice.idIndice}
                label={indice.nomeIndice}
                disabled={disabled}
                slotProps={{ textField: { fullWidth: true } }}
                //@ts-expect-error
                value={valor === '' || valor === undefined ? null : dayjs(valor, 'YYYY-MM-DD')}
                onChange={(newValue: Date | null) => {
                    //@ts-expect-error
                    onChange(newValue !== null ? newValue.format('YYYY-MM-DD') : '');
                }}
            />
        </Grid>
    );
};
